import { type ComponentType } from 'preact';

import { forwardRef } from 'preact/compat';

import { ErrorBoundaryWrapper } from './ErrorBoundary';

export const withErrorBoundary = <P,>(WrappedComponent: ComponentType<P>) => {
  const displayName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component';

  const ComponentWithErrorBoundary = forwardRef<any, P>((props, ref) => (
    <ErrorBoundaryWrapper>
      <WrappedComponent {...props} ref={ref} />
    </ErrorBoundaryWrapper>
  ));

  ComponentWithErrorBoundary.displayName = `withErrorBoundary(${displayName})`;

  return ComponentWithErrorBoundary;
};
